<template>
  <div class="map-switcher">
    <ul>
      <li
        :class="{ 'is-active': !isMapActive }"
        @click="isMapActive ? toggleMap() : null"
      >
        {{ tp('list') }}
      </li>
      <li
        :class="{ 'is-active': isMapActive }"
        @click="isMapActive ? null : toggleMap()"
      >
        {{ tp('map') }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Storages',
  inheritAttrs: false
};
</script>

<script setup>
import { prepared } from '@/helpers/i18n';

const props = defineProps({
  isMapActive: { type: Boolean, required: true },
  i18nKey: { type: String, required: true }
});
const emit = defineEmits(['toggle-map']);
const tp = prepared(props.i18nKey);

function toggleMap() {
  emit('toggle-map');
}
</script>

<style scoped lang="sass">
@import 'app/packs/stylesheets/functions/rem'
@import 'app/packs/stylesheets/mixins/responsive'
@import 'app/packs/stylesheets/variables'

.map-switcher
  bottom: rem(24px)
  left: 50%
  position: fixed
  transform: translateX(-50%)
  z-index: $z-index-sticky_area

  ul
    align-items: center
    background: var(--gray-200)
    border-radius: rem4(64px)
    box-shadow: 0px 0px 24.944px 0px rgba(3, 3, 3, 0.10)
    display: flex
    gap: rem4(4px)
    padding: rem4(4px)

    li
      background: var(--gray-200)
      border-radius: 32px
      display: flex
      font-size: rem4(16px)
      font-weight: 600
      line-height: rem4(20px)
      padding: rem4(10px) rem4(16px)
      transition: background var(--transition-duration)
      white-space: nowrap

      &:not(.is-active)
        cursor: pointer

      &.is-active
        background: #FFF
        box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.05)
</style>
